import { Color, FontWeight, rwd, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

import { Input as InputComponent } from '../../../components-deprecated/Form'
import { Themable } from '../../../types/themable'

export const LineInfo = styled.div<Themable>`
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
  margin-bottom: ${Spacing.S16};
  font-size: 14px;
`

export const ClickOption = styled.div<Themable>`
  margin: 8px 0;
  color: ${({ theme }) => theme.colors.newBlue1};
  font-size: 14px;
  font-weight: ${FontWeight.Medium};
  line-height: 20px;
  cursor: pointer;
`

export const Input = styled(InputComponent)`
  margin: 0;
`

export const LineInfoKey = styled.p<Themable>`
  color: ${({ theme }) => theme.colors.primaryGray};
`

export const LineInfoValue = styled.p<Themable>`
  color: ${Color.Black};
  font-weight: ${FontWeight.Medium};
`

export const LineInfoTotalKey = styled(LineInfoKey)<Themable>`
  color: ${Color.Black};
  font-size: 22px;
  font-weight: ${FontWeight.Medium};
`

export const LineInfoTotalValue = styled(LineInfoValue)<Themable>`
  color: ${Color.Black};
  font-size: 22px;
  font-weight: ${FontWeight.Medium};
`

export const LineInfoPlanValue = styled(LineInfoValue)<Themable>`
  color: ${Color.Black};
  font-weight: ${FontWeight.Medium};
`

export const LineSeparator = styled.div<Themable>`
  height: 1px;
  margin-bottom: ${Spacing.S24};
  background-color: ${Color.Grey150};
`

export const CouponContainer = styled.div`
  display: flex;

  ${rwd.equalOrLessThan('phone')} {
    flex-direction: column;
  }
`
